/* BackupDetailRenderer.js */

"use strict";

const {
    Control: {
        Action: {Button},
        Boolean: {InputCheckbox},
        Textfield: {InputText},
    },
} = require("@gluenetworks/steve_ui_core");

class BackupDetailRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("base-backup-veil-gl");
        this._rootElem.component = this._model;

        this.nameContainer = document.createElement("div");
        this.nameContainer.classList.add("backup-name-container");

        const nameLabel = document.createElement("label");
        nameLabel.innerText = "Name:";

        this._nameField = new InputText({
            darkTheme: true,
            placeholder: "Name",
            value: `Backup - ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
        });

        this.nameContainer.appendChild(nameLabel);
        this.nameContainer.appendChild(this._nameField.renderer.rootElement);

        this._devicesContainer = document.createElement("div");
        this._devicesContainer.classList.add("devices-container");

        this._devicesLabel = document.createElement("label");
        this._devicesLabel.innerHTML = "Devices:";

        this._unsupportedDevicesMsg = document.createElement("span");
        this._unsupportedDevicesMsg.classList.add("unsupported-devices-msg");

        this._runCapture = new InputCheckbox({
            label: "Capture new snapshot",
            labelShown: true,
            value: true,
            darkTheme: true,
        });

        this._confirmButton = new Button({
            label: "Start Backup",
            darkTheme: true,
        });

        this._cancelButton = new Button({
            label: "Cancel",
            darkTheme: true,
        });

        this._scheduleButton = new Button({
            label: "Schedule Backup",
            darkTheme: true,
        });

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model._title;

        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }

    _registerListeners() {
        this._confirmButton.on("UserClick", this._onConfirmButtonClick.bind(this));
        this._cancelButton.on("UserClick", this._onCancelButtonClick.bind(this));
        this._scheduleButton.on("UserClick", this._schedulePlanAction.bind(this));
        this._nameField.on("UserValue", (this._onNameChange = this._onNameChange.bind(this)));
    }

    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
        this._scheduleButton.removeListener("UserClick", this._schedulePlanAction);
        this._nameField.removeAllListeners("UserValue");
    }

    _onConfirmButtonClick() {
        this._callCreateAction();
    }

    _onCancelButtonClick() {
        this._model.cancelAction();
    }

    _callCreateAction() {
        this._model.backupAction(this._nameField.getValue() || "", this._runCapture.getValue());
    }

    _schedulePlanAction() {
        const workInput = this._getWorkInput();
        const scheduleName =
            "Device Backup - " +
            new Date().toLocaleDateString() +
            " " +
            new Date().toLocaleTimeString();

        return this._model.scheduleExport(scheduleName, workInput);
    }

    _onNameChange(val) {
        if (!val || val.trim().length === 0) {
            this._confirmButton.setDisabled(true);
            this._scheduleButton.setDisabled(true);
        } else {
            this._confirmButton.setDisabled(false);
            this._scheduleButton.setDisabled(false);
        }
    }

    _getWorkInput() {
        return {
            description: this._nameField.getValue(),
            runCapture: this._runCapture.getValue(),
        };
    }

    shutdown() {
        this._unregisterListeners();

        const promArr = [
            this._runCapture.shutdown(),
            this._confirmButton.shutdown(),
            this._cancelButton.shutdown(),
            this._nameField.shutdown(),
        ];

        return Promise.all(promArr)
            .then(() => {
                this._runCapture =
                    this._confirmButton =
                    this._buttonContainer =
                    this._titleComponent =
                    this._messageBox =
                    this._model =
                    this._rootElem =
                    this._cancelButton =
                        undefined;
            })
            .catch((err) => {
                this._model.logger.warn(err, "BaseCreateRenderer.shutdown() error");
            });
    }

    render() {
        return Promise.resolve().then(() => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);
                this._rootElem.appendChild(this.nameContainer);

                const runCaptureContainer = document.createElement("div");
                runCaptureContainer.classList.add("run-capture-container");
                runCaptureContainer.appendChild(this._runCapture.renderer.rootElement);
                this._rootElem.appendChild(runCaptureContainer);

                this._buttonContainer.appendChild(this._unsupportedDevicesMsg);
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._scheduleButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);
                this._rootElem.appendChild(this._buttonContainer);
            }

            return Promise.resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }
}

module.exports = BackupDetailRenderer;
